import { Link } from 'react-router-dom'
import classNames from 'classnames'
import { ReactComponent as ArrowRight } from '../../assets/svgs/arrow-right.svg'
import * as styles from './LinkWithArrow.module.scss'

const LinkWithArrow = ({ to, external, children, className, ...rest }) => (
  <>
    {external && (
      <a
        href={to}
        className={classNames(styles.linkWithArrowLink, className)}
        target="_blank"
        rel="noreferrer"
        {...rest}>
        {children}
        <ArrowRight className={styles.linkWithArrowLinkIcon} />
      </a>
    )}
    {!external && (
      <Link
        to={to}
        className={classNames(styles.linkWithArrowLink, className)}
        {...rest}>
        {children}
        <ArrowRight className={styles.linkWithArrowLinkIcon} />
      </Link>
    )}
  </>
)

export default LinkWithArrow
